import React, { FunctionComponent } from 'react'
import {ResponsiveButton} from './style'

type MainButtonProps = {
    color?: string,
    secondary?: boolean,
    disabled?: boolean,
}

const MainButton:FunctionComponent<MainButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>> = ({ color, secondary, disabled, ...props}) => {
    return (
        <ResponsiveButton color={color} secondary={secondary} disabled={disabled} {...props}>
            { props.children}
        </ResponsiveButton>
    )
}

export default MainButton
